import './App.css';
import { useState, useEffect, useRef } from 'react'
import { Avatar, Tabs, ImageViewer, MultiImageViewerRef } from 'antd-mobile'
import { LocationFill, PhoneFill } from 'antd-mobile-icons'
import { tabItems, previewImgs } from '@/api/source'

const tabHeight = 50

function SingleCard ({ data }: any) {
  const [visible, setVisible] = useState(false) // 弹窗是否可见
  const [curIndex, setCurIndex] = useState(0) // 当前预览的图片索引
  const imgViewerRef = useRef<MultiImageViewerRef>(null) // 预览组件的DOM

  // 键盘事件
  const handleKeyDown = (e: KeyboardEvent) => {
    if (!visible) return;
    // 弹窗出现时，阻止背景响应键盘事件
    e.preventDefault();
    if (e.key === 'ArrowLeft' && curIndex >= 1) {
      // 切换到上一张
      imgViewerRef?.current?.swipeTo(curIndex - 1);
    } else if (e.key === 'ArrowRight' && curIndex <= previewImgs[data.id].length - 2) {
      // 切换到下一张
      imgViewerRef?.current?.swipeTo(curIndex + 1);
    }
  };

  // 鼠标事件
  const handleWheel = (e: WheelEvent) => {
    if (!visible) return;
    // 弹窗出现时，阻止背景滚动
    e.preventDefault();
    if (e.deltaY > 0 && curIndex <= previewImgs[data.id].length - 2) {
      // 向下滚动 → 下一张
      imgViewerRef.current?.swipeTo(curIndex + 1);
    } else if (e.deltaY < 0 && curIndex >= 1) {
      // 向上滚动 → 上一张
      imgViewerRef.current?.swipeTo(curIndex - 1);
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    // 浏览器将某些事件(如 touchstart, touchmove, wheel 等)标记为"被动"(passive), 被动事件中不能调用 e.preventDefault()
    // 所以需要明确指定{ passive: false }，意思是 该事件为 非被动
    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('wheel', handleWheel)
    };
  }, [visible, data.id, curIndex])

  return (
    <div className='single-card' data-attr={data.id.startsWith('pc') ? 'pc' : ''}>
      <div
        className="card"
        onClick={() => {
          setVisible(true)
        }}>
        <img src={data.img} alt="" />
        <div className='info'>
          <span>{data.title}</span>
          <span>{data.info}</span>
        </div>
      </div>
      <ImageViewer.Multi
        ref={imgViewerRef}
        images={previewImgs[data.id]}
        visible={visible}
        defaultIndex={0}
        onClose={() => {
          setVisible(false)
        }}
        afterClose={() => {
          imgViewerRef?.current?.swipeTo(0)
        }}
        onIndexChange={(i) => {
          setCurIndex(i)
        }}
      />
    </div>
  )
}
function App() {
  const [activeKey, setActiveKey] = useState('1')

  const handleScroll =
    () => {
      let currentKey = tabItems[0].key
      for (const item of tabItems) {
        const element = document.getElementById(`anchor-${item.key}`)
        if (!element) continue
        const rect = element.getBoundingClientRect()
        if (rect.top <= tabHeight) {
          currentKey = item.key
        } else {
          break
        }
      }
      setActiveKey(currentKey)
    }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  return (
    <div>
      <div className="avatar">
        <div>
          <Avatar src={require('@/assets/img/image.jpeg')} style={{ '--size': '80px', '--border-radius': '40px' }} />
          <div className='info'>
            <span>张颖</span>
            <span><LocationFill />广州</span><br />
            <span>web前端开发</span>
          </div>
        </div>
        <a className="tel" href="tel:15361750628"><PhoneFill />联系我</a>
      </div>
      <div className='works'>
        <div className="tabsContainer">
          <Tabs
            activeKey={activeKey}
            onChange={key => {
              document.getElementById(`anchor-${key}`)?.scrollIntoView()
              window.scrollTo({
                top: window.scrollY - tabHeight,
              })
            }}
          >
            {tabItems.map(item => (
              <Tabs.Tab title={item.title} key={item.key} />
            ))}
          </Tabs>
        </div>
        <div className="content">
          {tabItems.map(item => (
            <div key={item.key}>
              <h5 id={`anchor-${item.key}`}>{item.title}</h5>
              <div className='list'>
                {item.content.map(v => <SingleCard data={v} key={v.id}></SingleCard>)}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='footer'>*受限于项目性质及资料收集，以上仅为部分项目作品</div>
    </div>
  );
}

export default App;
